//#region Libraries
import styled from "styled-components";
//#endregion

export const ContainerEventGraphics = styled.section`
    display: flex;
    gap: 15px;
`;
export const MessageZoomSelected = styled.span`
    font-size: 12px;
    font-weight: 400;
    color: var(--dark-4);
`;